const HOOK_TRIGGER_BUTTON = '[js-hook-product-tile-button-trigger]';
const ACTIVE_CLASS = 'is--visible';
const CAMPAIGN_PAGE_CLASS = '.is--campaign-page'

class ProductTileButton {
  constructor(element) {
    this.element = element;
    this.buttons = [...this.element.querySelectorAll(HOOK_TRIGGER_BUTTON)];

    const productViewID = this.buttons[0].getAttribute('aria-controls');
    this.productView = this.element.querySelector(`#${productViewID}`);

    this.bindEvents();

    // on campaign PD pages open button on page load
    if (this.element.closest(CAMPAIGN_PAGE_CLASS)) {
      this.toggleProductView();
    }
  }

  bindEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => this.toggleProductView());
    });
  }

  toggleProductView() {
    const productVisibility = this.productView.classList.contains(ACTIVE_CLASS);

    this.buttons[productVisibility ? 0 : 1].focus();

    this.setAriaAttributes(!productVisibility);
    this.productView.classList[productVisibility ? 'remove' : 'add'](ACTIVE_CLASS);
  }

  setAriaAttributes(productIsHidden) {
    this.productView.setAttribute('aria-hidden', !productIsHidden);
    this.buttons.forEach(button => {
      button.setAttribute('aria-expanded', productIsHidden);
    });
  }
}

export default ProductTileButton;
